<template>
    <b-modal size="md"
             centered
             hide-footer
             content-class="rounded-xl border-0 shadow-lg"
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                我的帳戶
            </strong>
        </template>

        <div class="pt-3 pb-2">
            <div class="text-center mb-2">
                <b-avatar variant="dark"
                          size="5.5rem"
                          v-bind:src="avatar">
                </b-avatar>
            </div>
            <h3 class="font-weight-bold text-center mb-2">
                {{ user.name }}
            </h3>
            <div class="mb-4">
                <p class="content text-center mb-2">
                    <font-awesome-icon v-bind:icon="['fad', 'at']"></font-awesome-icon>
                    {{ user.email }}
                </p>
                <p class="content text-center mb-0">
                    <font-awesome-icon v-bind:icon="['fad', 'phone']"></font-awesome-icon>
                    +{{ user.countryCode }} {{ user.phone }}
                </p>
            </div>

            <div class="d-flex">
                <button class="btn btn-light btn-block border mr-2">
                    編輯帳戶
                </button>
                <button class="btn btn-light btn-block border mt-0"
                        v-on:click="logout">
                    登出
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BAvatar, } from "bootstrap-vue";

export default {
    name: "ModalAccount",
    components: {
        BModal,
        BAvatar,
    },
    props: {
        "value": {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        user () {
            return this.$store.state.user.user;
        },
        userRole () {
            return this.$store.state.user.user.role;
        },
        avatar () {
            return this.user && this.user.avatar ?
                `${ this.$config.apiUrl }/${ this.$config.apiVersion }/user/avatar/${ this.user.avatar }` :
                "";
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },
        logout () {
            this.$store.dispatch("user/logout");
            this.$store.commit("tasks/clear");
            this.$store.commit("data/clear");
            this.$router.push("/login");
            this.hideModal();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
